module.exports = __webpack_public_path__ + "static/img/calvin.c7e0684.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success-stories/calvin.jpeg
// module id = bohh
// module chunks = 0